import './admin-status-badge.styl';

function AdminStatusBadge({ status }) {
  return (
    <span className={`admin-status-badge admin-status-badge--${status.replace(' ', '-')}`}>
      {status}
    </span>
  );
}

export default AdminStatusBadge;